import { DialogService } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { Autopay } from '../../models/autopay/';
import { Account } from '../../models/customer';
import { FeeCalculationType } from '../../models/feeCalculationType';
import { FeeCalculationValue } from '../../models/feeCalculationValue';
import { Portfolio } from '../../models/portfolio';
import { State } from '../../services/global-state';
import { HPFServiceClient } from '../../services/hpfApi';
import { AutopayService } from './autopay.service';
import { CancelAutopayDialog } from './cancel-autopay.dialog';
import numeral from 'numeral';

@autoinject
export class ViewAutopay {
	account: Account;
	portfolio: Portfolio;
	autopay: Autopay;
	isLoading = true;
	isTieredFees: boolean;
	allowFeesOnAutopays: boolean;

	constructor(
		private globalState: State,
		private router: Router,
		private hpfApi: HPFServiceClient,
		private dialogService: DialogService,
		private autopayService: AutopayService,
		private i18n: I18N
	) { }

	activate(model) {
		this.account = this.globalState.accounts.find((element, index, array) => {
			return element.id === model.id;
		});
		this.portfolio = this.globalState.customer.portfolios.find((element, index, array) => {
			return element.portfolioName === this.account.portfolioName;
		});
		this.allowFeesOnAutopays = this.portfolio.merchantSettings.feeSettings.allowFeesOnAutopays;
		this.autopayService.getLatestAutopay(this.account.customerAccountKey)
			.then((ap) => {
				this.autopayService.setFeeSettings(ap, this.allowFeesOnAutopays);
				this.autopay = ap;
				this.isTieredFees = this.autopayService.getIsTieredFees();
				this.isLoading = false;
				if (!ap) {
					this.showError(this.i18n.i18next.t('errorLoadingPageData', 'Error loading page data'));
				}
			});
	}

	goToEdit() {
		this.router.navigateToRoute('autopay/edit-autopay', { id: this.account.id });
	}

	showError(error: string) {
		alert(error);
	}

	cancelPlan() {
		this.dialogService.open({ viewModel: CancelAutopayDialog, lock: false })
			.whenClosed(response => {
				if (!response.wasCancelled) {
					this.hpfApi.deleteAutopay(this.autopay.key.toString())
						.then(result => {
							if (result.isSuccessful) {
								this.router.navigate('');
							} else {
								this.showError(this.i18n.i18next.t('autopayCancellationFailed', 'Failed to cancel autopay'));
							}
						})
						.catch(error => {
							this.showError(this.i18n.i18next.t('autopayCancellationFailed', 'Failed to cancel autopay'));
						});
				}
			});
	}

	getFormattedConvenienceFee(feeCalculationValue: FeeCalculationValue): string {
		return feeCalculationValue.feeCalculationType === FeeCalculationType.Percentage
			? `${numeral(feeCalculationValue.feeValue).format('0.[0000]')}%`
			: numeral(feeCalculationValue.feeValue).format('($0,0.00)');
	}
}
